import { useQuery } from '@tanstack/react-query';
import * as admin from '../../api/admin.ts';
import { formatBytes } from '../../lib/format.ts';

interface Card { label: string; value: string; sub?: string }

export function DashboardTab() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-stats'], queryFn: admin.stats, refetchInterval: 15_000,
  });

  if (isLoading || !data) return <span className="spinner" />;

  const saved = Math.max(0, data.logical_bytes - data.physical_bytes);
  const cards: Card[] = [
    { label: '사용자', value: data.users.toLocaleString() },
    { label: '파일', value: data.files.toLocaleString(), sub: `폴더 ${data.folders.toLocaleString()}` },
    { label: '버전', value: data.versions.toLocaleString(), sub: `블록 ${data.blocks.toLocaleString()}` },
    { label: '논리 용량', value: formatBytes(data.logical_bytes), sub: '모든 버전 합계' },
    {
      label: '실제 디스크', value: formatBytes(data.physical_bytes),
      sub: `중복제거로 ${formatBytes(saved)} 절약`,
    },
    { label: '중복제거율', value: `${data.dedup_ratio}×` },
    { label: '휴지통', value: formatBytes(data.trash_bytes), sub: '파기 대기 중' },
    { label: '실시간 연결', value: String(data.ws_connections), sub: 'WebSocket' },
  ];

  const ratio = data.logical_bytes === 0
    ? 0
    : Math.min(100, (data.physical_bytes / data.logical_bytes) * 100);

  return (
    <>
      <div className="stat-grid">
        {cards.map((card) => (
          <div key={card.label} className="stat">
            <div className="stat__label">{card.label}</div>
            <div className="stat__value">{card.value}</div>
            {card.sub && <div className="stat__sub">{card.sub}</div>}
          </div>
        ))}
      </div>

      <section className="panel">
        <h2>저장 효율</h2>
        <p className="panel__hint">
          같은 내용의 블록을 한 벌만 저장하기 때문에 실제 디스크 사용량이 논리 용량보다 적습니다.
        </p>
        <div className="quota__bar" style={{ height: 10 }}>
          <div className="quota__fill" style={{ width: `${ratio}%` }} />
        </div>
        <p className="quota__text">
          실제 {formatBytes(data.physical_bytes)} / 논리 {formatBytes(data.logical_bytes)}
          {saved > 0 && ` · ${formatBytes(saved)} 절약`}
        </p>
      </section>

      <section className="panel">
        <h2>모니터링</h2>
        <p className="panel__hint">
          Prometheus 지표는 <code>/metrics</code> 에서 수집할 수 있습니다.
        </p>
        <a className="btn btn--sm" href="/metrics" target="_blank" rel="noreferrer">
          /metrics 열기
        </a>
      </section>
    </>
  );
}
